import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

/** One quiet risk-reversal line under a decision-point button. Always links to /promises. */
export function GuaranteeLine({ children, className = "", testId = "guarantee-line" }) {
  return (
    <Link
      to="/promises"
      data-testid={testId}
      className={`ui group flex max-w-md items-start gap-2 text-left text-xs leading-[1.6] text-dim transition-colors hover:text-ink ${className}`}
    >
      <ShieldCheck className="mt-0.5 h-3.5 w-3.5 shrink-0 text-verify" aria-hidden="true" />
      <span>
        {children}{" "}
        <span className="link-u whitespace-nowrap">The promise in writing →</span>
      </span>
    </Link>
  );
}
